import { Skeleton } from 'antd';
import './index.less';

interface props {
  loading: boolean;
  children: React.ReactNode;
}

export const RevxSkeleton = (props: props) => {
  return <>{props.loading ? <Skeleton /> : <>{props.children}</>}</>;
};
